/**
 * The ARIA label for the years dropdown.
 *
 * @defaultValue `"Choose the Year"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
export function labelYearDropdown(options) {
    return "Choose the Year";
}
//# sourceMappingURL=labelYearDropdown.js.map